export interface AccountDTO {
    account: number;
    fromentityid: number;
    fromentityname: string;
    toentityid: number;
    toentityname: string;
    movementcount: number;
    lastmovementdate: string | null;
    currentbalance: number | null;
}

export interface AccountMovementListDTO {
    accountmovement: number;
    movementdate: string;
    description: string;
    amount: number;
    balance: number;
    /** Número del comprobante que originó el movimiento ("B 00003-00001234"); null si no tiene número. */
    formnumberdisplay: string | null;
}

export interface AccountMovementDetailItemDTO {
    description: string | null;
    nomenclatorcode: string | null;
    nomenclatordescription: string | null;
    quantity: number | null;
    unitprice: number | null;
    subtotal: number | null;
    vatamount: number | null;
    totalamount: number | null;
}

/** Estado del comprobante en ARCA (AFIPFormInvoicing.receiptState). */
export enum ArcaReceiptState {
    APPROVED = 1,
    REJECTED = 2,
    OBSERVED = 3,
}

/** Datos del comprobante que originó el movimiento. */
export interface AccountMovementFiscalFormDTO {
    formnumberdisplay: string | null;
    formletter: string | null;
    posnumber: number | null;
    formnumber: number | null;
    formdate: string | null;
    statedesc: string | null;
    /** El tipo de comprobante se autoriza en ARCA: solo entonces aplican receiptstate, cae y caedue. */
    externalnumber: boolean;
    receiptstate: ArcaReceiptState | null;
    cae: string | null;
    caedue: string | null;
    invoicingcompanyname: string | null;
}

export interface AccountMovementDetailDTO {
    accountmovement: number;
    movementdate: string | null;
    formtype: string | null;
    totalamount: number | null;
    paymentmethod: string | null;
    customername: string | null;
    fiscalform: AccountMovementFiscalFormDTO | null;
    items: AccountMovementDetailItemDTO[];
}

export interface AccountMovementAttachmentDTO {
    accountmovementattachment: number;
    accountmovement: number;
    filename: string;
    mimetype: string | null;
    publicurl: string | null;
    uploadedat: string | null;
}
